export { initGoogleMap, classStatus, initGoogleMapMulti } from './utils'